import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import shopikoIcon from "@baseImg/services/icon-shopiko.svg";
import shopikoStart from "@baseImg/services/circle/icon-plan-start.svg";
import shopikoBusiness from "@baseImg/services/circle/icon-plan-business.svg";
import shopikoPro from "@baseImg/services/circle/icon-plan-pro.svg";

const BG = {
	sliderSettings: {
		initialSlide: 0, // Focused slide on initial render (0,1,2,3 etc...)
		autoplay: false, // Autoplay slides
		centeredSlides: false, // Center initial slide
		centeredSlidesBounds: false, // Setup position on first and last slide when centeredSlides: true (if true, they will start from wrapper position)
		centerInsufficientSlides: true, // Center slides if slidesPerView > real number of slides
		startHintAnimation: true, // Start hint animation on initial render
		hintAnimationParams: {
			animateTo: 2,
			returnTo: 1
		},
		mousewheel: { // Allow control of the slider with the mouse wheel/trackpad
			forceToAxis: true, // horizontal wheel/trackpad gesture (ignore vertical scroll)
			releaseOnEdges: true // release the slider when it reaches the edges
		},
		wheelReleaseDelay: false // vertical scroll + horizontal slide animation
	},
	terms: {
		selected: 12,
		title: 'Показване на цени за:',
		options: [
			{
				id: 1,
				label: '1 месец',
				labelShort: '1 мес',
				months: 1,
				discountText: '',
				discountServiceType: 'PlanShop'
			},
			{
				id: 12,
				label: '12 месеца',
				labelShort: '12 мес',
				months: 12,
				discountText: 'до ',
				discountServiceType: 'PlanShop'
			}
		],
	},
	plans: [
		{
			serviceId: 'plan_gomba_shop_01',
			title: 'МагазинСтарт',
			description: 'Най-подходящ за първи онлайн магазин',
			descriptionSmall: '',
			characteristics: ``,
			flagText: '',
			breadCrumbMode: 'PlanShop',
			promoCode: '',
			showMonthlyPrice: true,
			icon: shopikoIcon,
			circleIcon: shopikoStart,
			buttonText: 'Поръчай сега',
			buttonAction: 'AddToCart',
			buttonParams: [
				'#contextCart#',
				'#serviceId#',
				'#servicePriceId#',
				'#term#',
				'#breadCrumbMode#',
				'#getPriceId#',
				'#promoCode#'
			],
			ButtonModal: '',
			ButtonModalParams: {},
			actionLinks: []
		},
		{
			serviceId: 'plan_gomba_shop_02',
			title: 'МагазинБизнес',
			description: 'Най-подходящ за цялостно решение на онлайн магазин',
			descriptionSmall: '',
			characteristics: ``,
			flagText: 'Най-предпочитан',
			breadCrumbMode: 'PlanShop',
			promoCode: '',
			showMonthlyPrice: true,
			icon: shopikoIcon,
			circleIcon: shopikoBusiness,
			buttonText: 'Поръчай сега',
			buttonAction: 'AddToCart',
			buttonParams: [
				'#contextCart#',
				'#serviceId#',
				'#servicePriceId#',
				'#term#',
				'#breadCrumbMode#',
				'#getPriceId#',
				'#promoCode#'
			],
			ButtonModal: '',
			ButtonModalParams: {},
			actionLinks: []
		},
		{
			serviceId: 'plan_gomba_shop_03',
			title: 'МагазинПро',
			description: 'Най-подходящ за онлайн магазин с всички екстри',
			descriptionSmall: '',
			characteristics: ``,
			flagText: '',
			breadCrumbMode: 'PlanShop',
			promoCode: '',
			showMonthlyPrice: true,
			icon: shopikoIcon,
			circleIcon: shopikoPro,
			buttonText: 'Поръчай сега',
			buttonAction: 'AddToCart',
			buttonParams: [
				'#contextCart#',
				'#serviceId#',
				'#servicePriceId#',
				'#term#',
				'#breadCrumbMode#',
				'#getPriceId#',
				'#promoCode#'
			],
			ButtonModal: '',
			ButtonModalParams: {},
			actionLinks: []
		}
	],
	charTitles: {
		plan_gomba_shop_01: 'Старт',
		plan_gomba_shop_02: 'Бизнес',
		plan_gomba_shop_03: 'Про'
	},
	noteData: [
		'* Посочените цени са валидни при покупка на нов Shopiko онлайн магазин за период от 12 месеца. Цените са с включен ДДС. Цените за подновяване на плановете ще откриеш в сравнителните характеристики по-долу.'
	]
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	sliderSettings: {
		initialSlide: 0, // Focused slide on initial render (0,1,2,3 etc...)
		autoplay: false, // Autoplay slides
		centeredSlides: false, // Center initial slide
		centeredSlidesBounds: false, // Setup position on first and last slide when centeredSlides: true (if true, they will start from wrapper position)
		centerInsufficientSlides: true, // Center slides if slidesPerView > real number of slides
		startHintAnimation: true, // Start hint animation on initial render
		hintAnimationParams: {
			animateTo: 2,
			returnTo: 1
		},
		mousewheel: { // Allow control of the slider with the mouse wheel/trackpad
			forceToAxis: true, // horizontal wheel/trackpad gesture (ignore vertical scroll)
			releaseOnEdges: true // release the slider when it reaches the edges
		},
		wheelReleaseDelay: false // vertical scroll + horizontal slide animation
	},
	terms: {
		selected: 12,
		title: 'Display prices for:',
		options: [
			{
				id: 1,
				label: '1 month',
				labelShort: '1 mo',
				months: 1,
				discountText: '',
				discountServiceType: 'PlanShop'
			},
			{
				id: 12,
				label: '12 months',
				labelShort: '12 mo',
				months: 12,
				discountText: 'up to ',
				discountServiceType: 'PlanShop'
			}
		],
	},
	plans: [
		{
			serviceId: 'plan_gomba_shop_01',
			title: 'Start',
			description: 'Perfect choice for launching your online store',
			descriptionSmall: '',
			characteristics: ``,
			flagText: '',
			breadCrumbMode: 'PlanShop',
			promoCode: '',
			showMonthlyPrice: true,
			icon: shopikoIcon,
			circleIcon: shopikoStart,
			buttonText: 'Add to cart',
			buttonAction: 'AddToCart',
			buttonParams: [
				'#contextCart#',
				'#serviceId#',
				'#servicePriceId#',
				'#term#',
				'#breadCrumbMode#',
				'#getPriceId#',
				'#promoCode#'
			],
			ButtonModal: '',
			ButtonModalParams: {},
			actionLinks: []
		},
		{
			serviceId: 'plan_gomba_shop_02',
			title: 'Business',
			description: 'Complete web solution for your online store',
			descriptionSmall: '',
			characteristics: ``,
			flagText: 'Recommended',
			breadCrumbMode: 'PlanShop',
			promoCode: '',
			showMonthlyPrice: true,
			icon: shopikoIcon,
			circleIcon: shopikoBusiness,
			buttonText: 'Add to cart',
			buttonAction: 'AddToCart',
			buttonParams: [
				'#contextCart#',
				'#serviceId#',
				'#servicePriceId#',
				'#term#',
				'#breadCrumbMode#',
				'#getPriceId#',
				'#promoCode#'
			],
			ButtonModal: '',
			ButtonModalParams: {},
			actionLinks: []
		},
		{
			serviceId: 'plan_gomba_shop_03',
			title: 'Pro',
			description: 'All the professional features for online store',
			descriptionSmall: '',
			characteristics: ``,
			flagText: '',
			breadCrumbMode: 'PlanShop',
			promoCode: '',
			showMonthlyPrice: true,
			icon: shopikoIcon,
			circleIcon: shopikoPro,
			buttonText: 'Add to cart',
			buttonAction: 'AddToCart',
			buttonParams: [
				'#contextCart#',
				'#serviceId#',
				'#servicePriceId#',
				'#term#',
				'#breadCrumbMode#',
				'#getPriceId#',
				'#promoCode#'
			],
			ButtonModal: '',
			ButtonModalParams: {},
			actionLinks: []
		}
	],
	charTitles: {
		plan_gomba_shop_01: 'Start',
		plan_gomba_shop_02: 'Business',
		plan_gomba_shop_03: 'Pro'
	},
	noteData: [
		'* The prices displayed are applicable exclusively to the purchase of a new Shopiko plan and include VAT. Renewal prices are listed in the comparison table below.'
	]
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];